import { gql } from '@apollo/client'

// Shared selection for a single announcement. The full `body` is fetched here so
// the inline feed/widget rows (line-clamped preview) and the detail modal
// (full text) share one payload — no per-id refetch when opening the modal.
export const ANNOUNCEMENT_FIELDS = gql`
  fragment AnnouncementFields on Announcement {
    id
    title
    body
    status
    published_at
    created_at
    updated_at
    type {
      id
      key
      label
      requires_ack
      priority
      active
    }
    author {
      id
      name
    }
    myReceipt {
      read_at
      acknowledged_at
    }
  }
`

// Baseline — the current user's feed, already sorted priority→newest by the API.
export const ANNOUNCEMENT_FEED = gql`
  ${ANNOUNCEMENT_FIELDS}
  query AnnouncementFeed($limit: Int, $offset: Int) {
    announcementFeed(limit: $limit, offset: $offset) {
      total
      unread_count
      announcements {
        ...AnnouncementFields
      }
    }
  }
`

// Org-wide management list (message.read.others) — all statuses, for the admin flow.
export const ANNOUNCEMENTS = gql`
  ${ANNOUNCEMENT_FIELDS}
  query Announcements($status: AnnouncementStatus, $limit: Int, $offset: Int) {
    announcements(status: $status, limit: $limit, offset: $offset) {
      total
      announcements {
        ...AnnouncementFields
      }
    }
  }
`

// A single announcement by id — used by the edit form, which is URL-reachable
// and so can't rely on the feed cache being warm.
export const ANNOUNCEMENT = gql`
  ${ANNOUNCEMENT_FIELDS}
  query Announcement($id: Int!) {
    announcement(id: $id) {
      ...AnnouncementFields
    }
  }
`

// Manager dashboard (message.read.receipts).
export const ANNOUNCEMENT_RECEIPT_SUMMARY = gql`
  query AnnouncementReceiptSummary($announcement_id: Int!) {
    announcementReceiptSummary(announcement_id: $announcement_id) {
      total
      read
      acknowledged
    }
  }
`

export const ANNOUNCEMENT_RECEIPTS = gql`
  query AnnouncementReceipts($announcement_id: Int!, $filter: AnnouncementReceiptFilter) {
    announcementReceipts(announcement_id: $announcement_id, filter: $filter) {
      recipient {
        id
        name
        email
      }
      delivered_at
      read_at
      acknowledged_at
    }
  }
`

// Type picker for authoring (baseline) and the type-management list.
export const ANNOUNCEMENT_TYPES = gql`
  query AnnouncementTypes($activeOnly: Boolean) {
    announcementTypes(activeOnly: $activeOnly) {
      id
      key
      label
      requires_ack
      priority
      active
    }
  }
`
